// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"e1887be7","799":"df9ec6e4"}[chunkId] + ".chunk.css";
};